import { StyleSheet } from 'react-native';
import { Background } from 'src/theme-v2/background';
import { Buttons } from 'src/theme-v2/buttons';
import { ColorTypography } from 'src/theme-v2/color-typography';
import { Alerts } from 'src/theme-v2/colors';
import { CornerRadius } from 'src/theme-v2/corner-radius';
import { Spacing } from 'src/theme-v2/spacing';
import { textLatoStyleDS } from 'src/theme-v2/text';

export const styles = StyleSheet.create({
  container: {
    paddingHorizontal: Spacing.Compact,
    paddingVertical: Spacing.Compact,
    gap: Spacing.Compact,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    ...textLatoStyleDS.TitleBoldXl,
    color: ColorTypography.TextColorPrimary,
  },
  closeIcon: {
    color: Buttons.ghostBlack.ButtonGhostBlackIconDefault,
    alignSelf: 'center',
  },
  groupTab: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: Spacing.Compact,
    justifyContent: 'space-between',
  },
  groupTabLeftContent: {
    flexShrink: 1,
    gap: Spacing.Micro,
    flexDirection: 'column',
  },
  groupTabRightContent: {
    flexShrink: 0,
    gap: Spacing.Compact,
    flexDirection: 'row',
    alignItems: 'center',
  },
  groupTitle: {
    ...textLatoStyleDS.BodyBoldMd,
    color: ColorTypography.TextColorInteractive,
  },
  numberBadgeContainer: {
    height: Spacing.Relaxed,
  },
  numberBadgeWarning: {
    color: ColorTypography.TextColorInverted,
  },
  numberBadge: {
    color: ColorTypography.TextColorSecondary,
  },
  arrowIcon: {
    color: Buttons.ghost.ButtonGhostIconDefault,
    width: Spacing.Tight,
    height: Spacing.Tight,
  },
  groupsListContainer: {
    flexDirection: 'column',
    gap: Spacing.Condensed,
  },
  groupButton: {
    paddingHorizontal: Spacing.Compact,
    paddingVertical: Spacing.Condensed,
    width: '100%',
    gap: Spacing.Micro,
    backgroundColor: Background.BackgroundColorBrand,
    borderRadius: CornerRadius.Normal,
  },
  warningText: {
    ...textLatoStyleDS.BodyRegularXs,
    color: Alerts.Red500,
  },
});
